import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Capital Greek sigma — the summation operator (Σ). Drawn as a single
 *  zig-zag polyline: top serif, descend to centre vertex, ascend to
 *  bottom serif. Tiny serif terminals (the inset notches at top-right
 *  and bottom-right) keep the glyph from reading as a generic "Z". */
export function IcnSigma(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="sigma">
      <path d="M12.5 3 H3.5 L8 8 L3.5 13 H12.5" />
      <path d="M12.5 3 V4.5" />
      <path d="M12.5 13 V11.5" />
    </Svg>
  );
}
